import {
  createStateReceiver,
  TIMESTAMP_REGISTRAR_KEY,
} from '@wix/communities-forum-client-commons';

export function subscribeToChange(store, onChange) {
  const stateReceiver = createStateReceiver();
  let accumulatedState = null;
  store.subscribe(() => {
    const { state, prevState, diff, partialState } = stateReceiver(store.getState());

    if (!accumulatedState) {
      accumulatedState = partialState;
    } else {
      accumulatedState = Object.assign(accumulatedState, partialState);
    }

    if (
      diff.length === 0 // if state hasn't changed we dont want to transmit props through the postMessage ("bridge")
    ) {
      return;
    }

    accumulatedState[TIMESTAMP_REGISTRAR_KEY] = state[TIMESTAMP_REGISTRAR_KEY];

    onChange(accumulatedState);
    accumulatedState = null;
  });
}
